export const multiDayCategoryDataKeys = [
  // Popular (same curated set as listing “Most-Booked” / Popular strip before marine-life duplication)
  {
    id: '66c5a193-f9ff-44f7-a963-8ac28ae831b2',
    projectType: ['popular'],
    location: '',
  },
  {
    id: '68aecd92-f569-4ae3-b9e7-f90acb951eb0',
    projectType: ['popular'],
    location: '',
  },
  {
    id: '672dfacb-896b-4b69-ad23-571f2e990fdb',
    projectType: ['popular'],
    location: '',
  },
  {
    id: '68a6edf3-d4fd-420d-8783-9bbf68b8efc2',
    projectType: ['popular'],
    location: '',
  },
  {
    id: '69496b04-5ae6-4a68-8140-70f50a8ab6ac',
    projectType: ['popular'],
    location: '',
  },
  {
    id: '6852d1f9-0c0d-47cc-a49c-750311382830',
    projectType: ['popular'],
    location: '',
  },
  {
    id: '68529bf2-8cee-44cd-9adb-8849057be0bd',
    projectType: ['popular'],
    location: '',
  },
  {
    id: '68c9287a-f893-401d-aa8f-43baca81fe47',
    projectType: ['popular'],
    location: '',
  },
  // Europe (location-based)
  {
    id: '66c5a193-f9ff-44f7-a963-8ac28ae831b2',
    projectType: [],
    location: 'europe',
  },
  {
    id: '6825b646-fade-4bf7-bc64-db7822638bb8',
    projectType: [],
    location: 'europe',
  },
  {
    id: '67fa5d57-dc56-465c-8e3a-b4d450208e82',
    projectType: [],
    location: 'europe',
  },
  {
    id: '67a0e9f5-37e3-451b-a4f4-43b65a10bdc9',
    projectType: [],
    location: 'europe',
  },
  {
    id: '69496b04-5ae6-4a68-8140-70f50a8ab6ac',
    projectType: [],
    location: 'europe',
  },
  {
    id: '67289723-8c8b-4166-b4e6-d2a4978da7a8',
    projectType: [],
    location: 'europe',
  },
  {
    id: '68c9287a-f893-401d-aa8f-43baca81fe47',
    projectType: [],
    location: 'europe',
  },
  {
    id: '6728cde0-a28c-4f9b-9607-07c7bc3497b8',
    projectType: [],
    location: 'europe',
  },
  // Marine life / Meeresschutz
  {
    id: '68a6edf3-d4fd-420d-8783-9bbf68b8efc2',
    projectType: ['marine-life'],
    location: '',
  },
  {
    id: '66c5a193-f9ff-44f7-a963-8ac28ae831b2',
    projectType: ['marine-life'],
    location: '',
  },
  {
    id: '68f6524d-7bcb-4513-8018-2b65735639b6',
    projectType: ['marine-life'],
    location: '',
  },
  {
    id: '68f7500c-7ab8-47a7-9b96-204e7437b4c8',
    projectType: ['marine-life'],
    location: '',
  },
  {
    id: '6852d1f9-0c0d-47cc-a49c-750311382830',
    projectType: ['marine-life'],
    location: '',
  },
  {
    id: '67a0e9f5-37e3-451b-a4f4-43b65a10bdc9',
    projectType: ['marine-life'],
    location: '',
  },
  {
    id: '68ee1ed7-33d6-4789-828e-5dc1a16001a1',
    projectType: ['marine-life'],
    location: '',
  },
  {
    id: '69a6b78a-11c2-4986-a70c-6bd290ff67a2',
    projectType: ['marine-life'],
    location: '',
  },
  // Wildlife / Tiere
  {
    id: '672dfacb-896b-4b69-ad23-571f2e990fdb',
    projectType: ['wildlife'],
    location: '',
  },
  {
    id: '67fa5d57-dc56-465c-8e3a-b4d450208e82',
    projectType: ['wildlife'],
    location: '',
  },
  {
    id: '67253385-cbd4-4946-a6ca-39b1875bbcb3',
    projectType: ['wildlife'],
    location: '',
  },
  {
    id: '6921921b-3ed6-4616-a47f-5c49334e101d',
    projectType: ['wildlife'],
    location: '',
  },
  {
    id: '6936f88c-00d0-45a8-8f02-3a0db7f9aaac',
    projectType: ['wildlife'],
    location: '',
  },
  {
    id: '68c9287a-f893-401d-aa8f-43baca81fe47',
    projectType: ['wildlife'],
    location: '',
  },
  {
    id: '689effe7-4f4a-4853-a584-5a8f5b6f2612',
    projectType: ['wildlife'],
    location: '',
  },
  {
    id: '68e51bdf-1f69-4c5c-a582-435da3b7f36b',
    projectType: ['wildlife'],
    location: '',
  },
  // Roundtrip / Rundreise
  {
    id: '68aecd92-f569-4ae3-b9e7-f90acb951eb0',
    projectType: ['roundtrip'],
    location: '',
  },
  {
    id: '69b44840-0813-46e9-b632-d693341fdb82',
    projectType: ['roundtrip'],
    location: '',
  },
  {
    id: '69b43a5e-b57a-4622-b95c-c27c17378c89',
    projectType: ['roundtrip'],
    location: '',
  },
  {
    id: '69bd26e2-8217-4c9f-bedf-93ffced8a4db',
    projectType: ['roundtrip'],
    location: '',
  },
  {
    id: '69c3f6d2-3714-4ecd-909f-60fde592a5d8',
    projectType: ['roundtrip'],
    location: '',
  },
  {
    id: '69bc2f69-58df-469c-a4e9-539ebe6c91cd',
    projectType: ['roundtrip'],
    location: '',
  },
  {
    id: '69bd4fe5-f3be-472d-b5c1-fea67eb3bf39',
    projectType: ['roundtrip'],
    location: '',
  },
  {
    id: '6866e2e8-00d0-4a0a-8721-d79a1b3277e3',
    projectType: ['roundtrip'],
    location: '',
  },
  // Getaway / Kurztrip
  {
    id: '69496b04-5ae6-4a68-8140-70f50a8ab6ac',
    projectType: ['getaway'],
    location: '',
  },
  {
    id: '67fa5d57-dc56-465c-8e3a-b4d450208e82',
    projectType: ['getaway'],
    location: '',
  },
  {
    id: '6825b646-fade-4bf7-bc64-db7822638bb8',
    projectType: ['getaway'],
    location: '',
  },
  {
    id: '68ee1ed7-33d6-4789-828e-5dc1a16001a1',
    projectType: ['getaway'],
    location: '',
  },
  {
    id: '69a6b31a-849e-447b-87a2-63397327ff0a',
    projectType: ['getaway'],
    location: '',
  },
  {
    id: '67289723-8c8b-4166-b4e6-d2a4978da7a8',
    projectType: ['getaway'],
    location: '',
  },
  {
    id: '687f6281-7596-431a-bb32-8ef620cd52cd',
    projectType: ['getaway'],
    location: '',
  },
  {
    id: '69a6b78a-11c2-4986-a70c-6bd290ff67a2',
    projectType: ['getaway'],
    location: '',
  },
  // Long-term (content may not all be live yet)
  {
    id: '68c9287a-f893-401d-aa8f-43baca81fe47',
    projectType: ['long-term'],
    location: '',
  },
  {
    id: '68f6524d-7bcb-4513-8018-2b65735639b6',
    projectType: ['long-term'],
    location: '',
  },
  {
    id: '69fb31e2-cd93-4c53-9251-7fc0571c1843',
    projectType: ['long-term'],
    location: '',
  },
  {
    id: '692d8bf3-9664-4c6a-be4c-c69739a69c65',
    projectType: ['long-term'],
    location: '',
  },
  {
    id: '689effe7-4f4a-4853-a584-5a8f5b6f2612',
    projectType: ['long-term'],
    location: '',
  },
  {
    id: '69259aaa-72a6-4ffd-925a-6566f8d2067f',
    projectType: ['long-term'],
    location: '',
  },
  {
    id: '672dfacb-896b-4b69-ad23-571f2e990fdb',
    projectType: ['long-term'],
    location: '',
  },
  {
    id: '6728de98-6be0-4833-93a0-24d35945cfe9',
    projectType: ['long-term'],
    location: '',
  },
];

export const uniqueAccomodationCategoryKeys = [
  {
    id: '64d56d78-7c8e-4b2e-9398-a90e6edb40be',
    projectType: ['stays'],
    location: '',
  },
  {
    id: '62ba9f2d-f348-4467-9d82-ed33b970644d',
    projectType: ['stays'],
    location: '',
  },
  {
    id: '67054f87-f314-4ca0-ac1f-d7e8449ab102',
    projectType: ['stays'],
    location: '',
  },
  {
    id: '65f34f9e-2975-4931-ab4d-8144eb85686b',
    projectType: ['stays'],
    location: '',
  },
  {
    id: '65f34f9e-2975-4931-ab4d-8144eb85686b',
    projectType: ['stays'],
    location: '',
  },
  {
    id: '61027bc1-cffc-4b23-bf8d-c0763b67cd3c',
    projectType: ['stays'],
    location: '',
  },
  {
    id: '63eabf21-34e1-4e52-bc90-3e812f2aee00',
    projectType: ['stays'],
    location: '',
  },
  {
    id: '60e462cb-1cd7-469a-b724-8c7ad5713ad5',
    projectType: ['stays'],
    location: '',
  },
  {
    id: '63eabf21-34e1-4e52-bc90-3e812f2aee00',
    projectType: [''],
    location: 'italy',
  },
  {
    id: '6233ba15-0b00-42a1-9992-d46b03f5196d',
    projectType: [''],
    location: 'italy',
  },
  {
    id: '65b260e0-46a3-40ba-9f84-c52fcadede57',
    projectType: [''],
    location: 'italy',
  },
  {
    id: '63e10db5-5aec-454c-a271-60a52e044141',
    projectType: [''],
    location: 'italy',
  },
  {
    id: '67054f87-f314-4ca0-ac1f-d7e8449ab102',
    projectType: [''],
    location: 'italy',
  },
  {
    id: '624e9b3e-8ff3-40d4-bd7b-de7c590856d1',
    projectType: [''],
    location: 'italy',
  },
  {
    id: '64d8879e-75c2-430f-a98c-c3ae632992e9',
    projectType: [''],
    location: 'italy',
  },
  {
    id: '6527b6a3-2846-4750-8f1b-b3e0ddcb3009',
    projectType: [''],
    location: 'italy',
  },
  {
    id: '6405e21f-39e0-4971-9acb-9797d9057c78',
    projectType: [''],
    location: 'spain',
  },
  {
    id: '606c6f7d-012d-41cb-bd14-5faa5c89739c',
    projectType: [''],
    location: 'spain',
  },
  {
    id: '637b84b3-24f6-457d-b369-795fb9f9206c',
    projectType: [''],
    location: 'spain',
  },
  {
    id: '6260fe27-cd80-42e8-8f46-7924f7ec555a',
    projectType: [''],
    location: 'spain',
  },
  {
    id: '62a099e0-2f16-4714-aad6-4e6d38da4185',
    projectType: [''],
    location: 'spain',
  },
  {
    id: '65284e68-a0d7-4079-9ebd-51445e20744e',
    projectType: [''],
    location: 'spain',
  },
  {
    id: '68593324-13ca-4ca7-963a-8bb9c6528bfb',
    projectType: [''],
    location: 'spain',
  },
  {
    id: '68593324-13ca-4ca7-963a-8bb9c6528bfb',
    projectType: [''],
    location: 'spain',
  },
  {
    id: '65a6fd8a-68c5-41bb-bc71-bccdd0716988',
    projectType: [''],
    location: 'colombia',
  },
  {
    id: '64d56d78-7c8e-4b2e-9398-a90e6edb40be',
    projectType: [''],
    location: 'colombia',
  },
  {
    id: '62337420-e9af-43f0-98d3-8efd7edbe433',
    projectType: [''],
    location: 'colombia',
  },
  {
    id: '62824e8f-1520-4b76-8ebf-0b7acd0833be',
    projectType: [''],
    location: 'colombia',
  },
  {
    id: '67432667-fcb4-4241-b7fb-bc4f6d2d8ef3',
    projectType: [''],
    location: 'colombia',
  },
  {
    id: '6617f9c0-afe0-4339-a61f-0d980ed77117',
    projectType: [''],
    location: 'colombia',
  },
  {
    id: '60fe3a9d-e47f-44e9-aeb4-90981cef49cb',
    projectType: [''],
    location: 'colombia',
  },
  {
    id: '65ef2abf-5528-477c-88d9-4aa618a54e8a',
    projectType: [''],
    location: 'colombia',
  },
  {
    id: '66ed642a-6aa7-437b-94eb-405f1747042b',
    projectType: [''],
    location: 'indonesia',
  },
  {
    id: '65fc1944-9b63-4eff-818c-e5bec37f0bec',
    projectType: [''],
    location: 'indonesia',
  },
  {
    id: '633d6100-ca35-428a-81e9-1f89dd128aa6',
    projectType: [''],
    location: 'indonesia',
  },
  {
    id: '63baab8a-16a4-4ba4-820a-f3e1aad15299',
    projectType: [''],
    location: 'indonesia',
  },
  {
    id: '62c39f3d-014d-4bba-94fd-c9ccd251a3ac',
    projectType: [''],
    location: 'indonesia',
  },
  {
    id: '63c02289-830e-4058-971e-7dec423998e5',
    projectType: [''],
    location: 'indonesia',
  },
  {
    id: '6319a89b-d28b-4e3e-9c8e-3a3cf34554dd',
    projectType: [''],
    location: 'indonesia',
  },
  {
    id: '62deafa0-5661-4bb7-a058-ea7c1166cf3b',
    projectType: [''],
    location: 'indonesia',
  },
  {
    id: '672d21e6-2806-4249-81ff-24dd56e52f6b',
    projectType: [''],
    location: 'ecuador',
  },
  {
    id: '63a8df6a-2550-4c28-8839-d0b354e53301',
    projectType: [''],
    location: 'ecuador',
  },
  {
    id: '656a50f4-c3d6-4cbb-9188-4fb3a9f1e196',
    projectType: [''],
    location: 'ecuador',
  },
  {
    id: '6560b5d1-44aa-477e-9556-80951e2e09fe',
    projectType: [''],
    location: 'ecuador',
  },
  {
    id: '6065caa6-39a5-438b-a862-7fd72e8943ee',
    projectType: [''],
    location: 'ecuador',
  },
  {
    id: '60ef5b8d-6522-4a26-8f90-59ca26caa873',
    projectType: [''],
    location: 'ecuador',
  },
  {
    id: '62827b0e-6c9b-4d56-a355-7b79a06b0d6f',
    projectType: [''],
    location: 'ecuador',
  },
  {
    id: '64e666f9-9013-4738-838c-9df05bf7900e',
    projectType: [''],
    location: 'ecuador',
  },
  {
    id: '640ece10-c9fe-4722-8c2b-1f5063f8e766',
    projectType: [''],
    location: 'namibia',
  },
  {
    id: '60e462cb-1cd7-469a-b724-8c7ad5713ad5',
    projectType: [''],
    location: 'namibia',
  },
  {
    id: '62c842b0-66d4-4981-811b-44a25a3107cf',
    projectType: [''],
    location: 'namibia',
  },
  {
    id: '62a1ff2e-ba58-4f87-bdc6-c3b3b3b04055',
    projectType: [''],
    location: 'namibia',
  },
  {
    id: '62a0ce34-b8bf-4f85-9365-58bff1a12257',
    projectType: [''],
    location: 'namibia',
  },
  {
    id: '62a1d5b5-b9a8-4374-ae55-a69589aa1f61',
    projectType: [''],
    location: 'namibia',
  },
  {
    id: '66740023-f55d-4328-8dbe-db50bb199dd6',
    projectType: [''],
    location: 'namibia',
  },
  {
    id: '642c5223-51c6-45a6-8b6a-9626e67cd86d',
    projectType: [''],
    location: 'namibia',
  },
  {
    id: '62ba9f2d-f348-4467-9d82-ed33b970644d',
    projectType: ['farm'],
    location: '',
  },
  {
    id: '62948640-5641-4269-8189-2f8dee66343d',
    projectType: ['farm'],
    location: '',
  },
  {
    id: '628e8233-d722-4d54-ada5-2a660f8e9515',
    projectType: ['farm'],
    location: '',
  },
  {
    id: '624b0eb7-42ca-4174-81cb-892f9e72fce5',
    projectType: ['farm'],
    location: '',
  },
  {
    id: '624a91f2-0c05-4b1f-939a-169d8a210e16',
    projectType: ['farm'],
    location: '',
  },
  {
    id: '63eabf21-34e1-4e52-bc90-3e812f2aee00',
    projectType: ['farm'],
    location: '',
  },
  {
    id: '62e38e49-3c21-449d-b910-bf45f3584ef9',
    projectType: ['farm'],
    location: '',
  },
  {
    id: '60be7ff5-e970-4951-a69d-d0b8d2b5d8fb',
    projectType: ['farm'],
    location: '',
  },
  {
    id: '65f34f9e-2975-4931-ab4d-8144eb85686b',
    projectType: ['nature'],
    location: '',
  },
  {
    id: '62ba9f2d-f348-4467-9d82-ed33b970644d',
    projectType: ['nature'],
    location: '',
  },
  {
    id: '63a41e4e-00b4-41e2-b721-45f9a15a0e39',
    projectType: ['nature'],
    location: '',
  },
  {
    id: '62a0ce34-b8bf-4f85-9365-58bff1a12257',
    projectType: ['nature'],
    location: '',
  },
  {
    id: '664c3b0f-449f-4ccb-bc55-59e07c246298',
    projectType: ['nature'],
    location: '',
  },
  {
    id: '63db30ec-883e-4f0f-90f8-2986bb1ecb02',
    projectType: ['nature'],
    location: '',
  },
  {
    id: '63768548-8d40-4b0a-a7c9-54fd8101c7bb',
    projectType: ['nature'],
    location: '',
  },
  {
    id: '65284e68-a0d7-4079-9ebd-51445e20744e',
    projectType: ['nature'],
    location: '',
  },
  {
    id: '624b0eb7-42ca-4174-81cb-892f9e72fce5',
    projectType: ['family'],
    location: '',
  },
  {
    id: '624a91f2-0c05-4b1f-939a-169d8a210e16',
    projectType: ['family'],
    location: '',
  },
  {
    id: '63eabf21-34e1-4e52-bc90-3e812f2aee00',
    projectType: ['family'],
    location: '',
  },
  {
    id: '60be7ff5-e970-4951-a69d-d0b8d2b5d8fb',
    projectType: ['family'],
    location: '',
  },
  {
    id: '64b2571b-ce5b-4f7e-a123-d676bc2db504',
    projectType: ['family'],
    location: '',
  },
  {
    id: '628e8233-d722-4d54-ada5-2a660f8e9515',
    projectType: ['family'],
    location: '',
  },
  {
    id: '63eabf21-34e1-4e52-bc90-3e812f2aee00',
    projectType: ['family'],
    location: '',
  },
  {
    id: '63eabf21-34e1-4e52-bc90-3e812f2aee00',
    projectType: ['family'],
    location: '',
  },
  {
    id: '6076f135-d5ac-46a0-9694-45f04752505e',
    projectType: ['islands'],
    location: '',
  },
  {
    id: '6319a89b-d28b-4e3e-9c8e-3a3cf34554dd',
    projectType: ['islands'],
    location: '',
  },
  {
    id: '633f1dc7-70ce-4a5e-863f-d5e49cbf9e15',
    projectType: ['islands'],
    location: '',
  },
  {
    id: '623af249-cc7e-4fe4-8223-b825f4a96d71',
    projectType: ['islands'],
    location: '',
  },
  {
    id: '63205ffd-8860-406f-ba26-b212dff41215',
    projectType: ['islands'],
    location: '',
  },
  {
    id: '61027bc1-cffc-4b23-bf8d-c0763b67cd3c',
    projectType: ['islands'],
    location: '',
  },
  {
    id: '62c39f3d-014d-4bba-94fd-c9ccd251a3ac',
    projectType: ['islands'],
    location: '',
  },
  {
    id: '62f676a1-3a55-48ff-96a8-bb2e1bbe83f1',
    projectType: ['islands'],
    location: '',
  },
];
